import styled from 'styled-components'
import CommonStyles from 'shared/style/commonPageStyles'

const Style = {
	Wrapper: CommonStyles.PageWrapper,

	RadioDiv: styled.span`
		display: flex;
		gap: 16px;
	`,
	Radio: styled.button`
		display: flex;
		align-items: center;
		gap: 8px;
	`,
}

export default Style
